<template>
	<div class="install">
		<div class="install_wrap">
			<div class="close_btn" @click="onCancelClick"></div>
			<div class="install_wrap_scroll">
				<div class="install_title">节点小宝主机端绑定指南</div>
				<div class="install_step">
					<div class="install_step_num">1</div>
					<div class="install_step_name">安装小宝</div>
					<div class="install_step_line"></div>
					<div class="install_step_num install_step_num_2">2</div>
					<div class="install_step_name install_step_name_2">
						打开小宝
					</div>
					<div class="install_step_line"></div>
					<div class="install_step_num">3</div>
					<div class="install_step_name">自动绑定</div>
				</div>
				<div class="install_sub_title">打开节点小宝</div>
				<div class="install_sub_desc">
					打开节点小宝，点击 “立即绑定” 即可完成主机绑定
				</div>
				<div class="install_bind">
					<div class="install_bind_img install_bind_img_01">
						<div class="text1">发现新的主机设备</div>
						<div class="icon"></div>
						<div class="text2">群晖NAS</div>
						<div class="btns">
							<div class="btn1">取消</div>
							<div class="btn2">立即绑定</div>
						</div>
					</div>
					<div class="install_bind_img install_bind_img_02">
						<div class="text1">绑定主机成功</div>
						<div class="icon"></div>
					</div>
				</div>
				<div class="install_sub_title">绑定失败</div>
				<div class="install_sub_desc">
					如您在绑定过程中有任和问题可联系小宝客服
				</div>
				<div class="install_bind" v-if="false">
					<img src="../../assets/node/nobind/phone_img.png" />
				</div>
				<div class="install_contact">
					<div
						class="install_contact_item install_contact_item_wechat"
					>
						<div class="install_contact_icon"></div>
						<div class="install_contact_text">扫码添加微信客服</div>
					</div>
					<div
						class="install_contact_item install_contact_item_phone"
					>
						<div class="install_contact_icon"></div>
						<div class="install_contact_phone">0755-86607260</div>
						<div class="install_contact_text">客服热线</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		onCancelClick: function () {
			this.$emit("onCancelClick");
		},
	},
};
</script>

<style lang="less" scoped>
.install {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background-color: rgba(82, 82, 82, 0.36);
	z-index: 10;
	.install_wrap::-webkit-scrollbar {
		display: none;
	}
	.install_wrap {
		position: absolute;
		width: 620px;
		height: 460px;
		left: 50%;
		top: 50%;
		margin-left: -310px;
		margin-top: -230px;
		background-color: RGBA(252, 252, 252, 1);
		border-radius: 5px;
		padding-top: 1px;

		-ms-overflow-style: none;
		scrollbar-width: none;
		.install_wrap_scroll {
			width: 620px;
			height: 460px;
			overflow-y: scroll;
			-ms-overflow-style: none;
			scrollbar-width: none;
		}
		.install_wrap_scroll::-webkit-scrollbar {
			display: none;
		}

		.install_title {
			color: rgba(33, 55, 108, 1);
			font-size: 20px;
			font-weight: bolder;
			text-align: center;
			background-image: url(../../assets/node/nobind/install_title.png);
			width: 269px;
			background-size: 100% auto;
			background-position: left center;
			background-repeat: no-repeat;
			margin: 0 auto;
			margin-top: 50px;
		}
		.install_step {
			text-align: left;
			margin-left: 80px;
			margin-top: 38px;
			.install_step_num.install_step_num_2 {
				background: rgba(31, 93, 227, 1);
				border-radius: 15px;
				color: rgba(252, 252, 252, 1);
				box-shadow: 0px 2px 4px 0px rgba(51, 94, 159, 0.16);
			}
			.install_step_num {
				width: 30px;
				height: 30px;
				display: inline-block;
				vertical-align: top;
				background-image: url(../../assets/node/nobind/install_step_num.png);
				background-size: 100% 100%;
				text-align: center;
				line-height: 30px;
				color: rgba(102, 102, 102, 1);
				font-size: 20px;
			}
			.install_step_name {
				display: inline-block;
				vertical-align: top;
				color: rgba(26, 26, 26, 1);
				margin-left: 7px;
				font-size: 14px;
				height: 31px;
				line-height: 31px;
			}
			.install_step_name.install_step_name_2 {
				color: rgba(31, 93, 227, 1);
				font-weight: bolder;
			}
			.install_step_line {
				width: 62px;
				height: 1px;
				background-color: rgba(200, 200, 200, 1);
				margin-top: 15px;
				display: inline-block;
				vertical-align: top;
				margin-left: 7px;
				margin-right: 7px;
			}
		}
		.install_sub_title {
			margin-left: 50px;
			margin-top: 30px;
			background-image: url(../../assets/node/nobind/install_sub_title.png);
			background-repeat: no-repeat;
			background-size: 7px 7px;
			background-position: left center;
			color: rgba(20, 78, 204, 1);
			padding-left: 18px;
			font-size: 17px;
			font-weight: bolder;
		}
		.install_sub_desc {
			color: rgba(102, 102, 102, 1);
			font-size: 14px;
			margin-left: 68px;
			margin-top: 2px;
		}
		.install_bind {
			text-align: center;
			margin-top: 15px;
			margin-bottom: 30px;
			.install_bind_img {
				display: inline-block;
				vertical-align: top;
			}
			.install_bind_img_01 {
				padding-top: 10px;
				width: 254px;
				height: 198px;
				margin-right: 20px;
				border: 1px solid #D4D9DB;
				border-radius: 3px;
				box-sizing: border-box;

				.text1{
					font-size: 14px;
					font-weight: 700;
				}
				.icon{
					margin: 0 auto;
					margin-top: 10px;
					width: 80px;
					height: 80px;
					background-image: url("../../assets/node/nobind/bind1.svg");
					background-size: 100% 100%;
				}
				.text2{
					margin-top: 5px;
					font-size: 12px;
					color: #1F5DE3;
					font-weight: 700;
				}
				.btns{
					margin-top: 10px;

					.btn1,.btn2{
						display: inline-block;
						width: 86px;
						height: 28px;
						line-height: 28px;
						border-radius: 20px;
						font-size: 12px;
					}
					.btn1{
						margin-right: 20px;
						background-color: #E6E6E6;
						color: #999999;
					}
					.btn2{
						background-color: #1F5DE3;
						color: #ffffff;
					}
				}
			}
			.install_bind_img_02 {
				padding-top: 30px;
				width: 254px;
				height: 198px;
				border: 1px solid #D4D9DB;
				border-radius: 3px;
				box-sizing: border-box;

				.text1{
					font-size: 20px;
					color: #1F5DE3;
					font-weight: 700;
				}
				.icon{
					margin: 0 auto;
					margin-top: 20px;
					width: 231px;
					height: 121px;
					background-image: url("../../assets/node/nobind/bind2.svg");
					background-size: 100% 100%;
				}
			}
			img {
				width: 360px;
			}
		}

		.install_contact {
			text-align: center;
			margin-bottom: 40px;
			margin-top: 20px;
			.install_contact_item {
				display: inline-block;
				vertical-align: top;
				width: 181px;
				height: 203px;
				border-radius: 4px;
				border: 1px solid rgba(210, 214, 219, 1);
				background-color: rgba(248, 248, 248, 0.5);
				.install_contact_icon {
					width: 126px;
					height: 126px;
					margin: 0 auto;
					margin-top: 20px;
				}
			}
			.install_contact_item_wechat {
				margin-right: 58px;
				.install_contact_icon {
					background-color: #cccccc;
					background-image: url(../../assets/common/kf_qrcode.jpg);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
				.install_contact_text {
					margin-top: 18px;
					color: rgba(102, 102, 102, 1);
					font-size: 12px;
				}
			}
		}
		.install_contact_item_phone {
			.install_contact_icon {
				background-image: url(../../assets/node/nobind/phone.png);
				background-repeat: no-repeat;
				background-position: center center;
				background-size: 90px 90px;
			}
			.install_contact_phone {
				margin-top: 5px;
				color: rgba(26, 26, 26, 1);
				font-size: 17px;
			}
			.install_contact_text {
				margin-top: 1px;
				color: rgba(102, 102, 102, 1);
				font-size: 12px;
			}
		}
	}

	.close_btn {
		width: 20px;
		height: 20px;
		position: absolute;
		right: 10px;
		top: 10px;
		background-image: url(../../assets/common/close4.svg);
		background-size: 100% 100%;
		cursor: pointer;
		z-index: 2;
	}
	.close_btn:hover {
		opacity: 0.8;
		cursor: pointer;
	}
}
</style>